export default __webpack_public_path__ + "static/LICAPS-GUARANTEE-347db133334b2511fc6d95ab767c8d8f.jpg";